export default __webpack_public_path__ + "../staticImages/sprite-postfinance-2x.png";